import OpenAI, { toFile } from 'openai';
import { guid4 } from 'shared-base';

let client: OpenAI | null = null;

export const init = (apiKey: string) => {
  client = new OpenAI({
    apiKey,
    dangerouslyAllowBrowser: true,
  });
};

export const styleTransfer = async (styleDescription: string, base64: string) => {
  try {
    if (!client) {
      throw new Error('OpenAI client not initialized');
    }

    const byteString = atob(base64);
    const byteArray = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      byteArray[i] = byteString.charCodeAt(i);
    }

    const file = await toFile(byteArray, `${guid4()}.png`, { type: 'image/png' });

    const response: any = await client.images.edit({
      model: 'gpt-image-1',
      prompt: `Apply a style transfer: ${styleDescription}`,
      quality: 'low', // @ts-ignore
      size: '1536x1024',
      image: file,
    });

    // '1024x1024', '1024x1536', '1536x1024', and 'auto'

    return response.data[0];
  } catch (err) {
    console.error('Error in styleTransfer:', err);
  }
};
